import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Accordion from '../../../../../components/Accordion';
import Table, {
  ColumnDefinitionType,
} from '../../../../../components/Table';
import { Loading } from '../../../../../components/Loading';
import { useHabilitacionContratista } from '../../../../../hooks/useHabilitacionContratista';
import { useUserLogin } from '../../../../../hooks/useUserLogin';
import { HabilitacionContratista } from '../../../../../types/HabilitacionContratista';
import { RootState } from '../../../../../app/store';
import {
  EN_PROCESO_STATUS_ID,
  HAB_OBSERVADA_STATUS_ID,
  HAB_ACTUALIZACION_STATUS_ID,
  HAB_APROBADA_STATUS_ID,
  HAB_REVISION_STATUS_ID,
} from '../../../../../constants/constants';

const buildColumns = (
  isContratista: boolean,
  isEmpresaGestora: boolean,
  isEmpresaSupervisora: boolean,
): ColumnDefinitionType<
  HabilitacionContratista,
  keyof HabilitacionContratista
>[] => [
  { key: 'id', header: 'Numero Habilitación' },
  { key: 'nombreEstado', header: 'Estado' },
  { key: 'nombreEmpresaGestora', header: 'Empresa Gestora' },
  { key: 'nombreContratista', header: 'Contratista' },
  {
    key: 'id',
    header: 'Acciones',
    cell: (data: HabilitacionContratista) => {
      const estado = data.idTipoEstado;
      // El lápiz aparece solo cuando el rol tiene una acción editable en ese estado
      // (misma lógica que el detalle de habilitación).
      const puedeEditar =
        (isContratista &&
          [
            EN_PROCESO_STATUS_ID,
            HAB_OBSERVADA_STATUS_ID,
            HAB_ACTUALIZACION_STATUS_ID,
            HAB_APROBADA_STATUS_ID,
          ].includes(estado)) ||
        ((isEmpresaGestora || isEmpresaSupervisora) &&
          estado === HAB_REVISION_STATUS_ID) ||
        (isEmpresaGestora && estado === HAB_APROBADA_STATUS_ID);

      return (
        <>
          <Link
            to={`/habilitacion-contratista/${data.id}?mode=view`}
            title="Visualizar"
          >
            <i
              className="fa fa-eye text-secondary me-2"
              aria-hidden="true"
            ></i>
          </Link>
          {puedeEditar && (
            <Link
              to={`/habilitacion-contratista/${data.id}`}
              title="Editar"
            >
              <i
                className="fa fa-pencil text-secondary me-2"
                aria-hidden="true"
              ></i>
            </Link>
          )}
        </>
      );
    },
  },
];

export const TablaHabilitacion = () => {
  const {
    habilitaciones,
    loading,
    handleLoading,
    buscarHabilitaciones,
  } = useHabilitacionContratista();
  const { permisos } = useSelector((state: RootState) => state.auth);
  const puedeCrear = permisos.includes('ALTA_CONTRATISTA');
  const {
    isContratistaTipoUsuario,
    isEmpresaGestoraTipoUsuario,
    isEmpresaSupervisoraTipoUsuario,
  } = useUserLogin();
  const isContratista = isContratistaTipoUsuario();
  const isEmpresaGestora = isEmpresaGestoraTipoUsuario();
  const isEmpresaSupervisora = isEmpresaSupervisoraTipoUsuario();
  const columns = buildColumns(
    isContratista,
    isEmpresaGestora,
    isEmpresaSupervisora,
  );

  useEffect(() => {
    handleLoading(true);
    buscarHabilitaciones();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Accordion
      id="accordionHabilitacionListado"
      title="Habilitaciones Contratista"
      iconoClass="fa fa-search mr-1"
      secondary={puedeCrear && isContratista}
      titleSecondary="Cargar Documentación"
      link="/habilitacion-contratista/nuevo"
    >
      <div className="table-responsive">
        {loading ? (
          <Loading />
        ) : (
          habilitaciones && (
            <Table
              data={habilitaciones || []}
              columns={columns}
              notResults="No existen habilitaciones para el criterio ingresado"
            />
          )
        )}
      </div>
    </Accordion>
  );
};
